import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormGroupDirective } from "@angular/forms";
import { forkJoin, Subscription } from "rxjs";
import { Yii } from "libraries/interfaces/Yii";
import { IFieldSpecs } from "libraries/module/formbuilder/fields/interfaces/field-specs";
import { IDropOption, locatorsList } from "libraries/module/formbuilder/forms/searchAirTrip/searchAirTrip.component";
import { PermissionResourceService } from "libraries/service/resources/permission/permissionResource.service";
import { ISamAgent } from "libraries/service/resources/sam/ISamAgent";
import { SamResourceService } from "libraries/service/resources/sam/samResource.service";
import { UserAuthService } from "libraries/service/user-auth/user-auth.service";
import { EAirSearchFields } from "app_locobook/air-search/e-air-search-fields";
import { AirSearchHeaderActionService } from "app_locobook/air-search/air-search-header/air-search-header-action/air-search-header-action.service";

class Wording {
    public readonly locator: string = Yii.t('wui-shared-js', "Agences");
}

@Component({
    selector: 'air-search-locator-form',
    templateUrl: './air-search-locator-form.component.html',
    styleUrls: ['./air-search-locator-form.component.scss']
})
export class AirSearchLocatorFormComponent implements OnInit, OnDestroy {
    public locatorFieldSpec: IFieldSpecs;
    public locatorItems: IDropOption[] = locatorsList;
    public airLocatorSearchForm: FormControl;
    public wording: Wording = new Wording();
    public airSearchForm: FormGroup;
    public airSearchLocatorFormSubscription: Subscription;
    private airSearchResetSubscription: Subscription;
    private locatorConfig: string;


    constructor(
        private readonly formGroupDirective: FormGroupDirective,
        protected readonly permissionResourceService: PermissionResourceService,
        protected readonly samResourceService: SamResourceService,
        protected readonly userAuthService: UserAuthService,
        private readonly airSearchHeaderActionService: AirSearchHeaderActionService,

    ) {
    }

    public ngOnInit(): void {
        this.initLocatorItems();
        this.initAirSearchResetSubscription();
    }

    public ngOnDestroy(): void {
        if (this.airSearchLocatorFormSubscription) {
            this.airSearchLocatorFormSubscription.unsubscribe();
        }
        if (this.airSearchResetSubscription) {
            this.airSearchResetSubscription.unsubscribe();
        }
    }

    private initAirSearchLocatorForm(): void {
        this.airLocatorSearchForm = new FormControl();
        this.airSearchForm = this.formGroupDirective.form;
        this.airSearchForm.addControl(EAirSearchFields.locator, this.airLocatorSearchForm);
        this.locatorFieldSpec = {
            formGroup: this.airSearchForm,
            formControlName: EAirSearchFields.locator,
            placeholder: Yii.t('wui-shared-js', 'Aucune préférence')
        };
    }

    private initAirSearchResetSubscription(): void {
        this.airSearchResetSubscription =
            this.airSearchHeaderActionService.resetAirSearchFormObservable.subscribe(() => {
                this.airLocatorSearchForm.setValue(this.locatorConfig);
            });
    }

    private initLocatorItems(): void {
        if (this.airSearchLocatorFormSubscription) {
            this.airSearchLocatorFormSubscription.unsubscribe();
        }
        this.airSearchLocatorFormSubscription = forkJoin([
            this.permissionResourceService.getPermissionsStartingWith(['iqba', 'profile']),
            this.samResourceService.getAgent(this.userAuthService.getUserId())
        ]).subscribe({
            next: ([permissions, contact]: [Set<string>, ISamAgent]): void => {
                if (Array.from(permissions).length) {
                    const locators: string[] = Array.from(permissions)
                        .filter((permission: string): boolean => permission.includes('.'))
                        .map((permission: string): string => permission.split('.').pop())
                        .filter(Boolean);
                    this.locatorConfig = contact?.link?.defaultLocator && locators.includes(contact?.link?.defaultLocator) ? contact.link.defaultLocator : null;
                    this.locatorItems = locators.map((locator: string): IDropOption => ({value: locator, label: locator}));
                    this.initAirSearchLocatorForm();

                    if (contact?.link?.defaultLocator && locators.includes(contact?.link?.defaultLocator) && !(this.airLocatorSearchForm.value && this.airLocatorSearchForm.value !== '')) {
                        this.airLocatorSearchForm.patchValue(contact?.link?.defaultLocator);
                    }
                }
            }
        });
    }

}